import React, { useState } from "react";
import { toast } from "sonner";
import { authApi } from "../api";

export default function Login({ onLoggedIn }) {
  const [email, setEmail] = useState("admin@damscarrental.com");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      const data = await authApi.login(email, password);
      localStorage.setItem("dams_token", data.token);
      localStorage.setItem("dams_user", JSON.stringify(data.user));
      toast.success("Welcome back, Admin!");
      onLoggedIn(data);
    } catch (err) {
      const msg = err?.response?.data?.detail || "Invalid credentials";
      toast.error("Login failed", { description: msg });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen flex items-start justify-center pt-24 px-4">
      <div className="card-soft w-full max-w-md p-8">
        <div className="mb-6">
          <div className="text-3xl font-extrabold tracking-tight">DAMS</div>
          <div className="dams-brand-sub">CAR RENTAL</div>
        </div>
        <p className="muted mb-6">Admin Panel Login</p>
        <form onSubmit={handleSubmit} className="space-y-3">
          <input
            type="text"
            className="input-soft"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="username"
          />
          <input
            type="password"
            className="input-soft"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
          />
          <button
            type="submit"
            disabled={submitting}
            className="pill-btn primary w-full mt-2"
            style={{ padding: "0.85rem" }}
          >
            {submitting ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
